import { css } from 'styled-components'
// import { minMq } from '../../shared/styles/breakPoints'
import variables from '../../shared/styles/variables'


const eventAddr = css`
  font-weight: bold;
`
const eventDate = css`
  color: ${variables.BASE_TXC};
`
const subEvent = css`
  color: ${variables.BASE_TXC};
  font-weight: bold;
`
const hisuiStrong = css`
  color: #ea502c;
`

export const no160Style = {
  eventAddr,
  eventDate,
  subEvent,
  hisuiStrong
}
